<template>
    <v-navigation-drawer
            permanent
            app
            floating
            fixed
            expand-on-hover
            color="secondary"
            class="drawer classic-drawer"
            :clipped="$vuetify.breakpoint.mdAndUp"
            style="z-index: 9999;"
            :mobile-break-point="1264">
        <div class="drawer__top">
            <div class="drawer__logo">
                <v-img class="drawer__logo-container"
                       :src="require('@/assets/img/logo--white.svg')">
                </v-img>
            </div>
            <v-divider class="nav-divider"
                       color="#e6e6e6">
            </v-divider>
            <v-list dense>
                  <router-link :to="`/projects`" active-class="drawer-item--active">
                      <v-list-item
                              v-ripple
                              class="drawer-item">
                          <v-list-item-action>
                              <img alt="Projects" :src="require(`@/assets/img/icons/nav/folder.svg`)"
                                   class="drawer-item__icon"/>
                          </v-list-item-action>
                          <v-list-item-content>
                              <v-list-item-title v-if="this.is_room_user">
                                  Rooms
                              </v-list-item-title>
                              <v-list-item-title v-else>
                                  Projects
                              </v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                  </router-link>
                  <router-link :to="`/community`" active-class="drawer-item--active">
                      <v-list-item
                              v-ripple
                              class="drawer-item">
                          <v-list-item-action>
                              <img alt="Communities" :src="require(`@/assets/img/icons/nav/community.svg`)"
                                   class="drawer-item__icon"/>
                          </v-list-item-action>
                          <v-list-item-content>
                              <v-list-item-title>
                                  Communities
                              </v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>
                  </router-link>
                <router-link v-if="can_see_admin" :to="'/users'">
                  <v-list-item
                          v-ripple
                          class="drawer-item">
                      <v-list-item-action>
                        <v-icon dark > mdi-shield-account-outline </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                              <v-list-item-title>
                                  Admin
                              </v-list-item-title>
                        </v-list-item-content>
                        </v-list-item>
                </router-link>
                <router-link v-if="can_see_admin" :to="'/monitoring'">
                  <v-list-item
                          v-ripple
                          class="drawer-item">
                      <v-list-item-action>
                        <v-icon dark > mdi-chart-line </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                              <v-list-item-title>
                                  Monitoring
                              </v-list-item-title>
                        </v-list-item-content>
                        </v-list-item>
                </router-link>
            </v-list>
        </div>
        <div class="drawer__bottom">
            <amplify-sign-out v-ripple v-bind:signOutConfig="signOutConfig"></amplify-sign-out>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { iamCan } from '../services/iam.service';
import { isRoomUser } from '../services/project.service';
    export default {
        name: "Drawer",
        data: () => ({
            signOutConfig: {
                signOutButton: 'Logout',
            },
            can_see_admin: false,
            project_label: "Projects",
            is_room_user: false,
        }),
        mounted() {
          this.is_room_user = isRoomUser();

          this. can_see_admin =  false;
          if (iamCan('list_users', null, null)) {
            this.can_see_admin = true;
          }

        }
    }
</script>

<style scoped>

</style>
